import React, { Component} from "react";
import { BallTriangle } from "react-loader-spinner";
import QRCode from "react-qr-code";
import PersonalInformationStep from "./PersonalInformationStep";
import { Button, Container, Form } from "react-bootstrap";
import Alert from 'react-bootstrap/Alert';



export type MaenadaAuthenticationQRProps = {
  onStatusChanged: (status: string) => void;
  token?: string;
  urlRepresentation?: string;
  offerId?: string;
 // onSignInComplete: (payload: AuthorizationResponsePayload) => void;
};

export interface AuthenticationQRState {
  //authRequestURIResponse?: GenerateAuthRequestURIResponse;
  uri?: string;
  originalUri?: string;
  status?: string;
}

export default class MaenadaAuthenticationQR extends Component<MaenadaAuthenticationQRProps> {
  public state: AuthenticationQRState = {};

  private registerStateSent: boolean = false;
  private refreshTimerHandle?: NodeJS.Timeout;
  private qrExpirationMs: number = 0;
  private timedOutRequestMappings: Set<AuthenticationQRState> =
    new Set<AuthenticationQRState>();
  private _isMounted: boolean = false;

  apiUrl = "https://dev-integration-ssi-agents.fra.nip-non-prod.cloud.netcetera.com";


  componentDidMount() {
    this.getOfferStatus();

    this._isMounted = true;
  }

  async getOfferStatus(){
    const params = new URLSearchParams(document.location.search);
    const transactionIdParam = params.get('transactionId');

    let transactionId = (transactionIdParam != null && transactionIdParam != "") ? transactionIdParam : this.props.offerId??"";

    let response = await fetch(this.apiUrl + "/openid4vci/offers/" + transactionId, {
      method: "GET",
      mode: 'cors',
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json"
      }
    });
  
    let statusResponse = await response.json();
    this.setState({status: statusResponse.status});
    if (this._isMounted && statusResponse.status == "CREATED"){
      setTimeout(() => {
        this.getOfferStatus();
      }, 2000);
    }
   }

  componentWillUnmount() {

    this.setState({});
    this._isMounted = false;
  }

  render() {
    return this.props.urlRepresentation? (
      <div>
         <Container>
          {
            (this.state?.status === "COMPLETED"?  <Alert key="success" variant="success"> Credential successfully issued! </Alert>: (this.state?.status === "FAILED"?  <Alert key="danger" variant="danger"> Credential issuance failed! </Alert>: <QRCode value={this.props.urlRepresentation ?? ""} />))
            
          }
          
        </Container>
        
      </div>
    ) : (
      <BallTriangle color="#352575" height="100" width="100" />
    );
  }
}
